import { Link } from "react-router-dom"
import styled from "styled-components"
import { getMapRoute } from "../../routes/routes"

type Props = {}

const Container = styled(Link)`
    background: white;
    font-family: "blokpol", sans-serif;

    font-size: 1.2rem;
    padding: 0.2em .5em .2em .2em;
    text-align: center;
    line-height: .9em;

    color: black;
    text-transform: uppercase;
    text-decoration: none;

    transition: .3s all;
    position: relative;

    &:before {
        content: '';
        width: 2em;

        background: white;

        left: -1em;

        position: absolute;
        top: 0;
        bottom: 0;

        transition: .3s all;
        clip-path: polygon(50% 0, 55% 0, 55% 100%, 50% 100%, 0 50%);
    }

    &:hover {
        background: black;
        color: white;

        &:before {
        background: black;
        }
    }
`

const BackLink: React.FC<Props> = () => {

    return <Container to={getMapRoute()}>
        Wróć<br />do{'\u00A0'}mapy
    </Container>
}

export default BackLink;
